// extracted by mini-css-extract-plugin
export var infoItem = "_rx-2";
export var title = "_rx-0";
export var value = "_rx-1";